import Navbar from "react-bootstrap/Navbar";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tooltip from "react-bootstrap/Tooltip";
import { styled } from "@mui/material/styles";

const StyledNavbar = styled(Navbar)(({ theme }) => ({
  backgroundColor: theme.palette.message?.backgroundcolor,
}))

const StyledTypography = styled("p")(({ theme }) => ({
  color: theme.palette.message?.textcolor,
}))

const Message = () => {
  return (
    <>
      <StyledNavbar className="w-75 mx-auto m-3  p-3 rounded" >
        <div className=" d-block">
          <Row className="justify-content-around align-items-center">
            <Col lg={12} md={12}>
              <StyledTypography className=" m-0" >
                SUCCESS MESSAGE:- Please enter flight details based on your confirmed Airline Itinerary or Ticket.
              </StyledTypography>
            </Col>
          </Row>
        </div>
      </StyledNavbar>
    </>
  )
}

export default Message
